import { GridRef, GridRefUtils } from '../../utils/helpers/GridRefPreference';
import {
  bearingUnitFromStored, DEFAULT_BEARING_UNIT, DEFAULT_NORTH_REFERENCE, MeasureBearingUnit, MeasureNorthReference,
  northReferenceFromStored,
} from './model/bearings';
import { MeasureGridFormat, resolveGridFormat } from './model/gridReference';
import { clampRangeTolerance } from './model/session';
import { safeLocalStorage } from './services/createHike';

/**
 * The measure tool's own settings. The web has no settings screen for them (the apps
 * keep them on the device), so they live in this browser; units follow the account.
 */
export interface MeasureSettings {
  northReference: MeasureNorthReference;
  bearingUnit: MeasureBearingUnit;
  gridFormat: MeasureGridFormat;
  toleranceMeters: number;
}

export const MEASURE_SETTINGS_KEY = 'hiiker.measureTool.settings';

function appGridRef(): GridRef {
  try {
    return GridRefUtils.preference().gridRef;
  } catch (error) {
    return GridRef.LatLon;
  }
}

/** Saved settings, each falling back on its own default; the grid format follows the account's grid until changed. */
export function loadMeasureSettings(
  storage: Pick<Storage, 'getItem'> | null = safeLocalStorage(),
  gridRef: GridRef = appGridRef(),
): MeasureSettings {
  let saved: any = {};
  try {
    saved = JSON.parse(storage?.getItem(MEASURE_SETTINGS_KEY) || '{}') || {};
  } catch (error) {
    saved = {};
  }
  return {
    northReference: northReferenceFromStored(saved.northReference) ?? DEFAULT_NORTH_REFERENCE,
    bearingUnit: bearingUnitFromStored(saved.bearingUnit) ?? DEFAULT_BEARING_UNIT,
    gridFormat: resolveGridFormat(saved.gridFormat, gridRef),
    toleranceMeters: clampRangeTolerance(saved.toleranceMeters),
  };
}

export function saveMeasureSettings(settings: MeasureSettings, storage: Pick<Storage, 'setItem'> | null = safeLocalStorage()): void {
  try {
    storage?.setItem(MEASURE_SETTINGS_KEY, JSON.stringify(settings));
  } catch (error) {
    // A full or blocked storage only loses the preference, not the measurement.
  }
}
